import React from "react";
import cn from "classnames";
import { PaginationLink, PaginationItem, Pagination } from "reactstrap";

const PAGE_RANGE_NUM = 5;

const PageLink = ({ to, children, ...rest }) => {
  const handleClick = e => {
    e.preventDefault();
    window.___navigate(to);
  };
  return (
    <PaginationLink to={to} {...rest} onClick={handleClick}>
      {children}
    </PaginationLink>
  );
};

/**
 *
 * @param {object} props
 * @param {number} props.curPage 当前页码
 * @param {number} props.minPage 最小页码
 * @param {number} props.maxPage 最大页码
 * @param {(targetPage: number) => void} props.onPageChange 页码变更回调
 * @returns
 */
const PaginationBar = ({ baseUrl, curPage, minPage = 1, maxPage, onPageChange }) => {
  if (minPage > maxPage) {
    [minPage, maxPage] = [maxPage, minPage];
  }

  const genaratePageList = () => {
    if (maxPage - 1 < minPage + 1) return [];
    let min;
    let max;
    if (curPage < Math.ceil(PAGE_RANGE_NUM / 2) + 1) {
      max = Math.min(maxPage - 1, PAGE_RANGE_NUM);
    } else {
      max = Math.min(maxPage - 1, curPage + Math.floor(PAGE_RANGE_NUM / 2));
    }
    if (curPage > maxPage - Math.ceil(PAGE_RANGE_NUM / 2)) {
      min = Math.max(minPage + 1, maxPage - PAGE_RANGE_NUM + 1);
    } else {
      min = Math.max(minPage + 1, curPage - Math.floor(PAGE_RANGE_NUM / 2));
    }
    return Array.from({ length: max - min + 1 }, (_, idx) => min + idx);
  };

  const pageList = genaratePageList();

  const getPageHref = page => {
    if (page === curPage || page < minPage || page > maxPage) {
      return "#";
    }
    return `${baseUrl}/page_${page}`;
  };

  return (
    <div className="col-sm-12">
      <Pagination listClassName="justify-content-center mb-0">
        <PaginationItem disabled={curPage === minPage}>
          <PageLink to={getPageHref(curPage - 1)} previous>
            上一页
          </PageLink>
        </PaginationItem>
        <PaginationItem
          disabled={curPage === minPage}
          className={cn({
            active: curPage === minPage,
          })}
        >
          <PageLink to={getPageHref(minPage)}>{minPage}</PageLink>
        </PaginationItem>
        {pageList[0] > minPage + 1 ? (
          <PaginationItem>
            <PageLink to={getPageHref(curPage - Math.ceil(PAGE_RANGE_NUM / 2))}>···</PageLink>
          </PaginationItem>
        ) : null}
        {genaratePageList().map((pageNum, idx) => (
          <PaginationItem
            key={`${pageNum}-${idx + 1}`}
            disabled={curPage === pageNum}
            className={cn({
              active: curPage === pageNum,
            })}
          >
            <PageLink to={getPageHref(pageNum)}>{pageNum}</PageLink>
          </PaginationItem>
        ))}
        {pageList[pageList.length - 1] < maxPage - 1 ? (
          <PaginationItem>
            <PageLink to={getPageHref(curPage + Math.ceil(PAGE_RANGE_NUM / 2))}>···</PageLink>
          </PaginationItem>
        ) : null}
        {minPage !== maxPage && (
          <PaginationItem
            disabled={curPage === maxPage}
            className={cn({
              active: curPage === maxPage,
            })}
          >
            <PageLink to={getPageHref(maxPage)}>{maxPage}</PageLink>
          </PaginationItem>
        )}
        <PaginationItem disabled={curPage === maxPage}>
          <PageLink to={getPageHref(curPage + 1)} next>
            下一页
          </PageLink>
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default PaginationBar;
